import { z } from 'zod'
import type { StoreAppSetting } from '../../models/AppSetting'
import {
  StoreBasicInfoDTOSchema,
  mapDTOToStoreBasicInfo,
  mapStoreBasicInfoToDTO
} from './StoreBasicInfoDTO'
import {
  StoreThemeSettingDTOSchema,
  mapDTOToStoreThemeSetting,
  mapStoreThemeSettingToDTO
} from './StoreThemeSettingDTO'
import {
  StoreContactDTOSchema,
  mapDTOToStoreContact,
  mapStoreContactToDTO
} from './StoreAppSettingsContactDTO'
import {
  StoreSocialMediaDTOSchema,
  mapDTOToStoreSocialMedia,
  mapStoreSocialMediaToDTO
} from './StoreSocialMediaDTO'
import {
  StoreFulfillmentSettingDTOSchema,
  mapDTOToStoreFulfillmentSetting,
  mapStoreFulfillmentSettingToDTO
} from './StoreFulfillmentSettingDTO'

export const StoreAppSettingDTOSchema = z.object({
  id: z.number().optional(),
  basic_info: StoreBasicInfoDTOSchema,
  theme: StoreThemeSettingDTOSchema,
  contacts: z.array(StoreContactDTOSchema).optional(),
  contact_notes: z.string().nullish(),
  social_media: z.array(StoreSocialMediaDTOSchema),
  fulfillment: StoreFulfillmentSettingDTOSchema.optional()
})

export type StoreAppSettingDTO = z.infer<typeof StoreAppSettingDTOSchema>

export function mapDTOToStoreAppSetting (dto: StoreAppSettingDTO): StoreAppSetting {
  return {
    id: dto.id,
    basicInfo: mapDTOToStoreBasicInfo(dto.basic_info),
    theme: mapDTOToStoreThemeSetting(dto.theme),
    contact: {
      channels: dto.contacts?.map(mapDTOToStoreContact) ?? [],
      notes: dto.contact_notes ?? undefined
    },
    socialMedia: dto.social_media.map(mapDTOToStoreSocialMedia),
    fulfillment: dto.fulfillment ? mapDTOToStoreFulfillmentSetting(dto.fulfillment) : undefined
  }
}

export function mapStoreAppSettingToDTO (model: StoreAppSetting): StoreAppSettingDTO {
  return {
    id: model.id,
    basic_info: mapStoreBasicInfoToDTO(model.basicInfo),
    theme: mapStoreThemeSettingToDTO(model.theme),
    contacts: model.contact?.channels?.map(mapStoreContactToDTO),
    contact_notes: model.contact?.notes ?? null,
    social_media: model.socialMedia.map(mapStoreSocialMediaToDTO),
    fulfillment: model.fulfillment ? mapStoreFulfillmentSettingToDTO(model.fulfillment) : undefined
  }
}
